module.exports = __webpack_public_path__ + "static/media/token-preview-rocket2.00d882f5.png";